<template>
  <div>
    <VoiceAgent />
  </div>
</template>

<script>
import VoiceAgent from "./components/VoiceAgent.vue";
export default {
  name: "App",
  components: { VoiceAgent },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

